import { useState } from 'react';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase-client';
import { v4 as uuidv4 } from 'uuid';
import TextInput from './formComponents/TextInput';
import { syncMemberCalendarToFamily } from '../../utils/syncFamilyCalendar';
export default function CreateFamilyForm({
  user,
  onCreated,
  onCancel
}) {
  const [familyName, setFamilyName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const handleSubmit = async e => {
    e.preventDefault();
    if (!familyName.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const familyId = uuidv4();
      const familyRef = doc(db, 'families', familyId);

      // Create the family document
      await setDoc(familyRef, {
        name: familyName,
        createdBy: user.uid,
        createdAt: serverTimestamp()
      });

      // Add the creator as a parent in the members subcollection
      await setDoc(doc(db, 'families', familyId, 'members', user.uid), {
        role: 'parent',
        addedBy: user.uid,
        addedAt: serverTimestamp()
      });
      await setDoc(doc(db, 'users', user.uid), {
        family_roles: {
          [familyId]: 'parent'
        }
      }, {
        merge: true
      });
      try {
        await syncMemberCalendarToFamily(db, user.uid, familyId);
      } catch (err) {}
      onCreated && onCreated(familyId);
    } catch (err) {
      setError('Failed to create family. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  return <form onSubmit={handleSubmit} className="flex-column" style={{
    gap: '1rem',
    maxWidth: 400
  }}>
      <TextInput label="Family Name" value={familyName} onChange={e => setFamilyName(e.target.value)} required />
      <div style={{
      display: 'flex',
      gap: '0.5rem',
      marginTop: '1rem'
    }}>
        <button className="button" type="submit" disabled={loading}>
          {loading ? 'Creating...' : 'Create Family'}
        </button>
        <button className="button button-secondary" type="button" onClick={onCancel} disabled={loading}>
          Cancel
        </button>
      </div>
      {error && <p style={{
      color: '#c0392b'
    }}>{error}</p>}
    </form>;
}
